// Automatically uses production URL on Netlify, local URL in dev
const isProd = import.meta.env.PROD;

export const BASE_URL = isProd
  ? "https://api.educareit.com:6025"
  : "http://127.0.0.1:8001";

export const STARTUP_API_URL = BASE_URL;
